var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutmeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66658 9.00004C8.66658 9.55233 8.36811 10 7.99992 10C7.63173 10 7.33325 9.55233 7.33325 9.00004C7.33325 8.44776 7.63173 8.00004 7.99992 8.00004C8.36811 8.00004 8.66658 8.44776 8.66658 9.00004Z",
    fill: "#1A1919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 9.00004C12.6666 9.55233 12.3681 10 11.9999 10C11.6317 10 11.3333 9.55233 11.3333 9.00004C11.3333 8.44776 11.6317 8.00004 11.9999 8.00004C12.3681 8.00004 12.6666 8.44776 12.6666 9.00004Z",
    fill: "#1A1919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 2.83337C6.02802 2.83337 2.83325 6.14578 2.83325 10.2004V15.1487C2.83325 16.3797 4.10823 17.2308 5.22832 16.6539C5.68275 16.4198 6.22316 16.4539 6.64763 16.7454C7.46564 17.3071 8.53419 17.3071 9.3522 16.7454L9.58731 16.584C9.83803 16.4118 10.1618 16.4118 10.4125 16.584L10.6476 16.7454C11.4656 17.3071 12.5342 17.3071 13.3522 16.7454C13.7767 16.4539 14.3171 16.4198 14.7715 16.6539C15.8916 17.2308 17.1666 16.3797 17.1666 15.1487V10.2004C17.1666 6.14578 13.9718 2.83337 9.99992 2.83337ZM3.83325 10.2004C3.83325 6.66994 6.60802 3.83337 9.99992 3.83337C13.3918 3.83337 16.1666 6.66994 16.1666 10.2004V15.1487C16.1666 15.6808 15.6403 15.9765 15.2294 15.7649C14.4464 15.3616 13.5128 15.4221 12.7861 15.9211C12.3092 16.2486 11.6907 16.2486 11.2137 15.9211L10.9786 15.7596C10.3868 15.3532 9.613 15.3532 9.02122 15.7596L8.78612 15.9211C8.30916 16.2486 7.69067 16.2486 7.21372 15.9211C6.48708 15.4221 5.55343 15.3616 4.77045 15.7649C4.35958 15.9765 3.83325 15.6808 3.83325 15.1487V10.2004Z",
    fill: "#1A1919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutmeIco);
export default __webpack_public_path__ + "static/media/aboutme-ico.1b35d8056ba10d5394b89c3a49e0ee02.svg";
export { ForwardRef as ReactComponent };